import { ApplicationState } from "#store/types";
import { PilotInterpretationService } from "#services/pilotService/pilotInterpretationService";
import { PilotOperatorInvocationService } from "#services/pilotService/pilotOperatorInvocationService";
import { PilotActionService } from "#services/pilotService/pilotActionService";
import { PilotDatasourceService } from "#services/pilotService/pilotDatasourceService";
import { PilotTableService } from "#services/pilotService/pilotTableService";
import { PilotSql2NLService } from "#services/pilotService/pilotSql2NLService";
import { PilotIdentifierRecommendationsService } from "#services/pilotService/pilotIdentifierRecommendationsService";

/**
 * sql-autocomplete requires a node-environment, which is not supported in the browser
 */
// import {
//     AutocompleteOption,
//     SQLAutocomplete,
//     SQLDialect
// } from "sql-autocomplete";

export const actionService = (
    url: string,
    userId: string
): PilotActionService => new PilotActionService(url, userId);
export const operatorInvocationService = (
    url: string,
    userId: string
): PilotOperatorInvocationService =>
    new PilotOperatorInvocationService(url, userId);
export const interpretationService = (
    url: string,
    userId: string
): PilotInterpretationService => new PilotInterpretationService(url, userId);
export const tableService = (url: string, userId: string): PilotTableService =>
    new PilotTableService(url, userId);
export const datasourceService = (
    url: string,
    userId: string
): PilotDatasourceService => new PilotDatasourceService(url, userId);
export const sql2nl = (state: ApplicationState): PilotSql2NLService =>
    new PilotSql2NLService(state);
export const idRecsService = (
    state: ApplicationState
): PilotIdentifierRecommendationsService =>
    new PilotIdentifierRecommendationsService(state);
